import { useContext } from 'react'
import { IsVarEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { ModalUtilsContext, ModalUtilsContextType } from '../Contexts/ModalUtilsContext'

export const useModalUtilsContext = (): ModalUtilsContextType => {
    const context: Definable<ModalUtilsContextType> = useContext(ModalUtilsContext)
    if (IsVarEmpty(context)) {
        throw new Error('useModalUtilsContext must be used within a ModalUtilsProvider')
    }
    return context
}
